import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    quote:
      "Kirana ki dukaan thi chhoti si. Ab WhatsApp pe 200+ orders aate hain roz. Website aur app sab Digital Onboarding ne banaya.",
    name: "Rajesh Gupta",
    role: "Gupta General Store, Lucknow",
    avatar:
      "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    quote:
      "Being a CSC center, I needed a professional website and payment gateway fast. Got everything live in 2 days. Worth every rupee.",
    name: "Anita Verma",
    role: "Verma CSC, Jaipur",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    quote:
      "The AI assistant replies to customers even when I sleep. My salon bookings have doubled in 2 months.",
    name: "Sneha Iyer",
    role: "Glow Salon, Pune",
    avatar:
      "https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?auto=format&fit=crop&w=200&h=200&q=80",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="uppercase text-xs tracking-[0.24em] text-violet-300 font-semibold">
            Loved across India
          </p>
          <h2
            data-testid="testimonials-heading"
            className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight"
          >
            Small shops,{" "}
            <span className="text-gradient">big online wins.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl glass p-7 border border-white/5 flex flex-col hover:-translate-y-1 hover:border-violet-500/40 transition-all"
            >
              <div className="flex gap-0.5 mb-4 text-amber-300">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-amber-300" />
                ))}
              </div>
              <blockquote className="text-slate-200 leading-relaxed text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="w-11 h-11 rounded-full object-cover border border-white/10 shadow-md shadow-violet-500/20"
                />
                <div>
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
